/**
 * Sidebar verdict display + list cache reconciliation.
 * Active project must never disagree with the live combined header verdict.
 */

/**
 * Resolve which verdict badge a sidebar row should show.
 * Active deal prefers live combined verdict; others keep persisted list values.
 */
export function displayVerdictForDeal(deal, { currentFileId = null, activeLiveVerdict = null } = {}) {
  const active = Boolean(deal?.id && currentFileId && deal.id === currentFileId);
  if (active && activeLiveVerdict?.verdict) {
    return {
      verdict: activeLiveVerdict.verdict,
      reason: activeLiveVerdict.reason || null,
      live: true,
    };
  }
  return {
    verdict: deal?.verdict || deal?.decision?.verdict || null,
    reason: deal?.reason || null,
    live: false,
  };
}

/**
 * Patch one deal in the sidebar list cache from a successful save response.
 * Non-matching rows are unchanged.
 */
export function reconcileDealListVerdict(deals, patch) {
  if (!Array.isArray(deals) || !patch?.id) return Array.isArray(deals) ? deals : [];
  let changed = false;
  const next = deals.map((deal) => {
    if (deal.id !== patch.id) return deal;
    changed = true;
    const updated = { ...deal };
    if (patch.verdict != null) updated.verdict = patch.verdict;
    if (patch.reason != null) updated.reason = patch.reason;
    if (patch.roi != null) updated.roi = patch.roi;
    if (patch.updatedAt != null) updated.updatedAt = patch.updatedAt;
    return updated;
  });
  return changed ? next : deals;
}

/** Build a reconcile patch from a server deal mutation payload. */
export function dealVerdictPatchFromServer(serverDeal, fallbackId = null) {
  if (!serverDeal && !fallbackId) return null;
  const id = serverDeal?.id || fallbackId;
  if (!id) return null;
  if (serverDeal?.verdict == null && serverDeal?.roi == null && serverDeal?.updatedAt == null) {
    return null;
  }
  return {
    id,
    verdict: serverDeal?.verdict ?? null,
    reason: serverDeal?.reason ?? null,
    roi: serverDeal?.roi ?? null,
    updatedAt: serverDeal?.updatedAt ?? null,
  };
}
